import React, { useRef } from "react"
import OndeffModal from "./OndeffModal"
import Button from '@mui/material/Button'

const QuoteRequestModalLibrary = props => {
  const btnLabel = props.btnLabel || "Get a quote"
  const childRef = useRef()
  const isOnCard = props.isOnCard || false

  const handleClick = () => {
    if (childRef.current) {
      childRef.current.triggerChangeShowModal()
    }
  }

  return (
    <>
      {" "}
      {isOnCard ? (
        <Button
          variant="contained"
          className="bookButton"
          onClick={handleClick}
          style={{lineHeight: "1.2em", marginBottom: "42px"}}
        >
          {btnLabel}
        </Button>
      ) : (
        <button
          style={{ cursor: "pointer" }}
          className={props.class}
          onClick={handleClick}
        >
          {btnLabel}
        </button>
      )}
      <OndeffModal {...props} ref={childRef} />
    </>
  )
}

export default QuoteRequestModalLibrary
